<template>
    <v-autocomplete
      v-model="internalValue"
      :items="parsedDropdownValues"
      item-value="value"
      item-text="text"
      :label="field.label"
      :required="field.is_required"
      outlined
      dense
      clearable
    ></v-autocomplete>
  </template>
  
  <script>
  export default {
    props: {
      modelValue: [String, Array],
      field: Object,
    },
    emits: ['update:modelValue'],
    computed: {
      parsedDropdownValues() {
        if (typeof this.field.dropdown_values === 'string') {
          return this.field.dropdown_values.split(',').map(value => ({
            text: value.trim(),
            value: value.trim()
          }));
        }
        return [];
      },

      internalValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        // console.log('Updating modelValue:', value);
        this.$emit('custom-update', value);
      }
    }
    }
  };
  </script>
  
  